import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_LEAVE_DETAILS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const LeaveDetails = lazy(() =>
  import('../../../screens/LeaveDetails')
    .then(module => ({default: module.LeaveDetails})));

const LeaveDetailsNavigation = [
  {
    path: ROUTE_LEAVE_DETAILS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <LeaveDetails />
      </Suspense>
    ),
  },
];

export default LeaveDetailsNavigation;
